module.exports = __webpack_public_path__ + "img/image_chip_focused.23f37860.png";